<template lang="pug">
.s-vstack.tight
  .s-vstack(v-for="(suggestion, index) in suggestions", :key="index")
    .s-hstack
      .caption {{ suggestion }}
      v-btn(text, x-small, @click="select(suggestion)", type="button", color="success") Select
    v-divider
</template>

<script>
export default {
  data() {
    return {
      suggestions: [
        "We've recovered a payment for this order. Please void if it is necessary.",
        "We've recovered a payment for this order. Now it is overpaid and please void the extra payment."
      ]
    }
  },
  methods: {
    select(suggestion) {
      this.$emit("select", suggestion);
    }
  }
}
</script>